import React, { useCallback } from 'react';
import Checkbox from '@atlaskit/checkbox';
import { Box, xcss } from '@atlaskit/primitives';
import { headingSizes as akHeadingSizes } from '@atlaskit/theme/typography';
import { sendUIEvent } from '../../../../../common/utils/analytics-client';
import { CookieCategory } from '../../../../../types';
const tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';

// Styles
const categoryBoxStyles = xcss({
  paddingBlockStart: 'space.200'
});
const categoryDescriptionStyles = xcss({
  color: 'color.text.subtle',
  paddingInlineStart: 'space.300',
  marginInlineStart: 'space.050',
  fontSize: `${akHeadingSizes.h200.size}px`,
  lineHeight: `${akHeadingSizes.h200.lineHeight}px`
});

// We don't bother tracking unknown checkbox toggles
const categoryToEventSubjectMap = {
  [CookieCategory.Analytics]: 'performanceConsent',
  [CookieCategory.Functional]: 'functionalConsent',
  [CookieCategory.Marketing]: 'targetingConsent',
  [CookieCategory.Unknown]: null
};
export const CookieCategorySection = ({
  category,
  titleElement,
  titleString,
  descriptionElement,
  isChecked,
  setPreferences
}) => {
  const onCheckboxChange = useCallback(() => {
    // Don't alter cookies that are strictly necessary
    if (category === CookieCategory.StrictlyNecessary) {
      return;
    }
    setPreferences(prevPreferences => {
      const isSelected = !prevPreferences[category];
      const actionSubjectId = categoryToEventSubjectMap[category];
      if (actionSubjectId) {
        sendUIEvent({
          actionSubjectId,
          action: 'clicked',
          actionSubject: 'checkbox',
          source: 'cookieConsentModal',
          attributes: {
            isSelected
          }
        });
      }
      return {
        ...prevPreferences,
        [category]: isSelected
      };
    });
  }, [category, setPreferences]);
  return /*#__PURE__*/React.createElement(Box, {
    xcss: categoryBoxStyles
  }, /*#__PURE__*/React.createElement(Checkbox
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
  , {
    className: `${tmpTrelloClassNameOverride}`,
    isChecked: isChecked,
    value: isChecked.toString(),
    onChange: onCheckboxChange,
    label: titleElement,
    name: `${titleString}`
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: categoryDescriptionStyles
  }, descriptionElement));
};